<template>
	<div class="pe-notice" :class="tone" role="status">
		<i class="fa-solid" :class="icon"></i>
		<span class="grow">{{ text }}</span>
		<button class="navbtn close" aria-label="Close" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></button>
	</div>
</template>

<script>
// Feedback that stays on the page until it is closed or replaced: no toast, nothing that vanishes after two seconds.
const ICONS = { ok: 'fa-check', warn: 'fa-triangle-exclamation', info: 'fa-circle-info' }

export default {
	name: 'PeNotice',
	props: { tone: { type: String, default: 'info' }, text: { type: String, default: '' } },
	computed: { icon() { return ICONS[this.tone] || ICONS.info } },
}
</script>
